import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  globalETitle: {
    id: `account.globale.title`,
    defaultMessage: 'Personal data',
  },

  globalEDescription: {
    id: `account.globale.description`,
    defaultMessage:
      'During the purchase on this website, you will share your personal data with Breitling and Global-e. Each of them is a separate and independent data controller and data processor. This means that Global-e collects your personal data which is required to manage and fulfil your purchase order (e.g. to invoice the products, verify payment details, process your payment, make refund, send you communication related to your purchase order, deliver the products). Global-e will share your personal data with Breitling, which will process it to manage and fulfil the purchase order placed by Global-e, to provide you with aftersales service care and to deal with any other of your enquiries and requests.',
  },
});
